import React, { useCallback, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Link, useHistory } from 'react-router-dom';
import { useApplication } from '../context/ApplicationContext';
import apiService from '../services/api.service';
import { resolveAssetUrl } from '../utils/assets';
import { appPath } from '../utils/appSlug';
import { formatRomeDateTime } from '../utils/datetime';
import FlashAlert from '../Components/FlashAlert/FlashAlert';
import './about.css';

const participateStorageKey = (eventId) => `course-participate-${eventId}`;

const About = ({ loginStatus, appSlug }) => {
	const history = useHistory();
	const { application } = useApplication();
	const isLoggedIn = Boolean(loginStatus?.sub);

	const [featuredEvent, setFeaturedEvent] = useState(null);

	const loadFeaturedEvent = useCallback(async () => {
		if (!appSlug) return;
		try {
			const response = await apiService.getFeaturedEventBySlug(appSlug);
			setFeaturedEvent(response.data);
		} catch {
			setFeaturedEvent(null);
		}
	}, [appSlug]);

	useEffect(() => {
		loadFeaturedEvent();
	}, [loadFeaturedEvent]);

	const alert = history.location.state?.successReason ? (
		<FlashAlert variant="success">{history.location.state.successReason}</FlashAlert>
	) : null;

	const title = featuredEvent?.name || application.site_title || application.name;
	const description = featuredEvent?.description || 'Non è presente un evento in programma.';
	const coverSrc = featuredEvent?.cover_url ? resolveAssetUrl(featuredEvent.cover_url) : null;
	const schedule = featuredEvent?.date ? formatRomeDateTime(featuredEvent.date) : null;

	const handleParticipate = () => {
		if (!featuredEvent?.id) return;
		sessionStorage.setItem(participateStorageKey(featuredEvent.id), 'true');
		history.push(appPath(appSlug, `course/${featuredEvent.id}`));
	};

	return (
		<div className="about-page">
			{alert && <div className="about-alerts">{alert}</div>}

			<div className="about-cover">
				{coverSrc ? (
					<img src={coverSrc} alt={title} className="about-cover__image" />
				) : (
					<div className="about-cover__placeholder">Copertina evento</div>
				)}
			</div>

			<div className="about-info">
				<h1 className="about-title">{title}</h1>
				<div className="about-description">
					<p>{description}</p>
					{schedule && (
						<p className="about-description__meta">In programma: {schedule}</p>
					)}
					{!isLoggedIn && featuredEvent && (
						<p className="about-description__login">
							Per partecipare all&apos;evento è necessario aver effettuato l&apos;accesso.{' '}
							<Link to={appPath(appSlug, 'login')}>Accedi ora</Link>
						</p>
					)}
				</div>

				{isLoggedIn && featuredEvent && (
					<div className="about-actions">
						<Button className="about-participate-btn" onClick={handleParticipate}>
							Partecipa all&apos;evento
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default About;
